/**Indica que una factura fue cancelada */
export interface CancelacionFactura {
    /**Id de la factura cancelada, note que esta es la llave primaria ya que una factura sólo se puede cancelar una vez */
    IdFactura: number;

    /**Fecha en la que se canceló la factura */
    FechaCancelacion: Date | string;

    /**Motivo de cancelación de la factura */
    MotivoCancelacion: string;
}

/**Estatus de la cancelacion */
export enum EstatusCancelacion {
    /**El comprobante fue cancelado exitosamente sin requerir aceptación */
    CanceladoSinAceptacion,

    /**El comprobante fue cancelado aceptando la solicitud de cancelación */
    CanceladoConAceptacion,

    /**El comprobante recibió una solicitud de cancelación y se encuentra en espera de una respuesta o aun no es reflejada */
    EnProceso,

    /**El comprobante no se cancelo porque se rechazo la solicitud de cancelación */
    Rechazada,

    /**El comprobante fue cancelado ya que no se recibió respuesta del receptor en el tiempo límite. */
    CanceladoPlazoVencido
}


// WEBPACK FOOTER //
// ./app/models/cancelacionfactura.ts